// extracted by mini-css-extract-plugin
export default {"paper":"search_main_snippet_card-module__paper--3asDr"};